module.exports = __webpack_public_path__ + "product_info-ultimate_it.jpg";